import React from 'react';
import { motion } from 'framer-motion';
import { SectionTag } from './SectionTag';
import { BONOS, BONOS_TOTAL } from './salesData';
export function BonosSection() {
  return <section id="bonos" className="bg-sand py-12 sm:py-16" data-id="element-26" data-mp="13dxnfow04t9k">
      <div className="mx-auto max-w-3xl px-5" data-id="element-27" data-mp="13ccuu4t8zkec">
        <div className="text-center" data-id="element-28" data-mp="yf2u3t0ermb7">
          <SectionTag data-id="element-29" data-mp="ye1ldv6v7bwn">+5 Bonos de regalo</SectionTag>
          <h2 className="mt-4 font-display text-[1.8rem] font-semibold leading-tight text-charcoal sm:text-[2.4rem]" data-id="element-30" data-mp="tfhx3o4sto14">
            Para que lo pongas en práctica más rápido
          </h2>
          <p className="mx-auto mt-3 max-w-xl font-sans text-sm leading-relaxed text-charcoal/70" data-id="element-31" data-mp="oizsqpddrrpb">
            Además del sistema principal, recibís 5 bonos diseñados para acelerar la
            implementación en tu día a día.
          </p>
        </div>

        <ul className="mt-7 divide-y divide-stone overflow-hidden rounded-2xl border border-stone bg-ivory" data-id="element-32" data-mp="2errs79pdce9z">
          {BONOS.map((bono, i) => <motion.li key={bono.num} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.3,
          delay: i * 0.04
        }} className="flex items-start gap-3 px-4 py-3.5" data-id="element-33" data-mp="qvednkb5pm42" data-mpi={i}>
              <span className="mt-0.5 font-sans text-sm font-bold leading-tight tabular-nums text-gold-deep/70" data-id="element-34" data-mp="muuekb70w8fa">
                {bono.num}
              </span>
              <div className="flex-1" data-id="element-35" data-mp="1ekz56rldlroy">
                <h3 className="font-display text-lg font-semibold leading-tight text-charcoal" data-id="element-36" data-mp="1ejp6q1am2hhs">
                  {bono.title}
                </h3>
                <p className="mt-0.5 font-sans text-[0.8rem] leading-snug text-charcoal/70" data-id="element-37" data-mp="10rrd6ytduu6q">
                  {bono.desc}
                </p>
              </div>
              <span className="mt-0.5 shrink-0 rounded-full bg-gold px-2.5 py-1 font-sans text-[0.6rem] font-bold uppercase tracking-[0.12em] text-charcoal" data-id="element-38" data-mp="1tgonaenfxkoe">
                Gratis
              </span>
            </motion.li>)}
        </ul>

        <div className="mt-5 rounded-2xl bg-charcoal px-5 py-4 text-center text-ivory" data-id="element-39" data-mp="23650c3pih7nq">
          <p className="font-sans text-sm sm:text-base" data-id="element-40" data-mp="1y6senmadm6mq">
            Valor total bonos{' '}
            <span className="tabular-nums opacity-60" style={{
            textDecoration: 'line-through'
          }} data-id="element-41" data-mp="1y8lo19cdj4yf">
              {BONOS_TOTAL}
            </span>{' '}
            → <span className="font-bold text-gold" data-id="element-42" data-mp="1p6vw82eky404">GRATIS con tu MegaPack</span>
          </p>
        </div>
      </div>
    </section>;
}